const formatPriority = ["avif", "webp", "png", "jpg", "jpeg"]
const toMime = (t: string) => (t === "jpg" ? "image/jpeg" : `image/${t}`)

const Image = ({
  image,
  priority = false,
  ...rest
}: {
  image: PictureImport
  className?: string
  sizes: string
  alt: string
  width: number
  height: number
  priority?: boolean
}) => {
  const orderedSources = Object.entries(image.sources)
    .sort(([a], [b]) => formatPriority.indexOf(a) - formatPriority.indexOf(b))
    .filter(([type]) => image.sources[type])

  return (
    <picture>
      {orderedSources.map(([type, srcset]) => (
        <source key={type} type={toMime(type)} srcSet={srcset} />
      ))}
      <img
        src={image.img.src}
        srcSet={image.sources.png || image.sources.jpg || image.sources.jpeg}
        fetchpriority={priority ? "high" : "auto"}
        decoding={priority ? "sync" : "async"}
        loading={priority ? "eager" : "lazy"}
        {...rest}
      />
    </picture>
  )
}

export default Image
